module.exports = __webpack_public_path__ + "media/pricing/DigitalStorage-ed223e4a.png";